import React from 'react'

export default function NiSearch() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.6"
                d="M22 22L18.5 18.5"
                stroke="currentColor"
                strokeWidth="1.5"
                stroke-linecap="round"
            ></path>
            <circle
                cx="11.5"
                cy="11.5"
                r="9.5"
                stroke="currentColor"
                strokeWidth="1.5"
            ></circle>
        </svg>
    )
}
